import { MutationHookOptions, useMutation } from '@apollo/client';

import mutation from './planDepotResetMutation.graphql';

export const usePlanDepotResetMutation = (
  opts?: MutationHookOptions<
    PlanDepotResetMutation,
    PlanDepotResetMutationVariables
  >,
) =>
  useMutation<PlanDepotResetMutation, PlanDepotResetMutationVariables>(
    mutation,
    opts,
  );
